export default __webpack_public_path__ + "mark-dark.c4f7a1b2c03db578e20b882d5af9d1b2.png";